export enum BumpResourceSheetType {
  REPAIR_PAYMENT = 'REPAIR_PAYMENT',
  JOB_BUMP_PHASE = 'JOB_PHASE_BUMP',
}
